import { SVGProps } from "react";

interface RightArrowProps extends SVGProps<SVGSVGElement> {}

export function RightArrow(props: RightArrowProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="#007CBF"
        d="m9.705 6-1.41 1.41 4.58 4.59-4.58 4.59L9.705 18l6-6-6-6Z"
      />
    </svg>
  );
}
